import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import LoraConfigForm from '../components/LoraConfigForm';
import * as loraConfigActions from '../redux/modules/loraConfigs';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  createLoraConfig: PropTypes.func,
  clearNewlyCreated: PropTypes.func,
  newlyCreatedId: PropTypes.number,
  t: PropTypes.func,
  currentUser: PropTypes.any,
};

const defaultProps = {
  newlyCreatedId: null,
};

class LoraConfigCreate extends React.Component {
  componentWillReceiveProps = (nextProps) => {
    if (!this.props.newlyCreatedId && nextProps.newlyCreatedId) {
      this.props.clearNewlyCreated();
      browserHistory.push(`/lora-configs/modify/${nextProps.newlyCreatedId}`);
    }
  };

  createLoraConfig = (values) => {
    this.props.createLoraConfig(values);
  };

  render() {
    const disableSave = !(this.props.currentUser && this.props.currentUser.role === 'SUPER_ADMIN');

    return (
      <PageBase title={this.props.t('create_new_lora_config')}>
        <LoraConfigForm
          onSubmit={this.createLoraConfig}
          isModify={false}
          data=""
          disableSave={disableSave}
        />
      </PageBase>
    );
  }
}

LoraConfigCreate.defaultProps = defaultProps;
LoraConfigCreate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    translate: getTranslate(state.locale),
    currentUser: state.auth.current,
    newlyCreatedId: state.loraConfigs.newlyCreatedId,
  };
}

const extended = translate(['translations'], { i18n })(LoraConfigCreate);
export default connect(mapStateToProps, loraConfigActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/LoraConfigCreate.js